import request from 'utils/request';

export default async function fetchTerritory(): Promise<any> {
  try {
    const { data: result } = await request(
      `/lineDriveService/territories/territory`,
      {
        method: 'GET'
      }
    );

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
